<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useDeviceManagementPrinterStatusStore } from '@nsftx/seven-client-retail-vue-dm'
import { NXGDSTooltip, NXGDSStatusIcon } from '@nsftx/seven-nxg-design-system'

const { printerStatus } = storeToRefs(useDeviceManagementPrinterStatusStore())

const showPrinterDamagedStatus = computed(
  () => printerStatus.value.code !== 'undefined' && printerStatus.value.code !== 'ok',
)
const printerStatusIconProps = computed(() => {
  if (printerStatus.value.code === 'warning') {
    return {
      icon: 'print-ng',
      variant: 'attention',
    } as const
  }

  return {
    icon: 'print-ng',
    variant: 'negative',
  } as const
})
</script>

<template>
  <NXGDSTooltip
    v-if="showPrinterDamagedStatus"
    :text="$t(printerStatus.message)"
    width="240px"
    :placement-offset="8"
  >
    <template #reference>
      <NXGDSStatusIcon
        v-bind="printerStatusIconProps"
        data-testid="ss-footer-printer-status-icon"
      />
    </template>
  </NXGDSTooltip>
</template>
